import { render, staticRenderFns } from "./TaLpTableGrid.vue?vue&type=template&id=2ca2d3dd&scoped=true"
import script from "./TaLpTableGrid.vue?vue&type=script&lang=js"
export * from "./TaLpTableGrid.vue?vue&type=script&lang=js"
import style0 from "./TaLpTableGrid.vue?vue&type=style&index=0&id=2ca2d3dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2d3dd",
  null
  
)

export default component.exports